import React from "react";

import { Stack } from "@mui/material";
import { GridCellParams, GridColDef } from "@mui/x-data-grid-pro";

import UserAvatar from "../components/UserAvatar";
import UserDisplayName from "../components/UserDisplayName";

function useUserInfoColumn(title: string) {
  const userInfoCol: GridColDef = {
    headerName: title,
    field: "user",
    flex: 2,
    valueGetter: (_value, row) => {
      return row?.user?.displayName || row?.user?.email || "";
    },
    renderCell: function UpdatedAtCell(params: GridCellParams) {
      return (
        <Stack
          direction="row"
          gap={1}
          alignContent="center"
          alignItems="center"
        >
          <UserAvatar variant="rounded" user={params.row?.user} />
          <UserDisplayName user={params.row?.user} />
        </Stack>
      );
    },
  };
  return userInfoCol;
}
export default useUserInfoColumn;
